import { render } from "./HomeDesafio.vue?vue&type=template&id=efc3ffcc"
import script from "./HomeDesafio.vue?vue&type=script&lang=js"
export * from "./HomeDesafio.vue?vue&type=script&lang=js"

import "./HomeDesafio.vue?vue&type=style&index=0&id=efc3ffcc&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__